import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './horariosvalores_team_probeach.module.scss';
import { FaArrowLeft } from 'react-icons/fa';

const WHATSAPP_NUMBER = '5516991207617';

const PLANOS = [
    {
        nome: 'Plano 1',
        valor: 'R$ 250',
        periodo: 'mensal',
        descricao: '3 treinos por semana',
    },
    {
        nome: 'Plano 2',
        valor: 'R$ 130',
        periodo: 'mensal',
        descricao: '2 treinos por semana',
    },
    {
        nome: 'Plano 3',
        valor: 'R$ 90',
        periodo: 'mensal',
        descricao: '1 treino por semana',
    },
];

function whatsappUrl(mensagem: string) {
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(mensagem)}`;
}

const Valores_team_probeach: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <Link to="/team_probeach" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h1 className={styles.title}>Valores</h1>
                </div>

                <section className={styles.section}>
                    <p className={styles.lead}>
                        Bem-vindo(a) ao <strong>Pro Beach | Vôlei de Praia</strong>!
                    </p>
                    <p className={styles.paragraph}>
                        Nossos treinos são divididos por nível, sendo{' '}
                        <strong>Iniciante</strong>, <strong>Intermediário</strong> e{' '}
                        <strong>Avançado</strong>, então você evolui no seu ritmo e com
                        acompanhamento de perto!
                    </p>
                    <p className={styles.paragraph}>
                        As aulas são conduzidas pelo <strong>Treinador Victor</strong>, formado em
                        Educação Física, personal trainer e com experiência na área esportiva.
                    </p>
                    <p className={styles.paragraph}>
                        Os treinos são feitos no <strong>Top Soccer (Bebedouro)</strong> —
                        garantindo um treino técnico, dinâmico e com muita evolução!
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Investimento individual</h2>
                    <p className={styles.sectionHint}>3 planos disponíveis</p>
                    <ul className={styles.planosList}>
                        {PLANOS.map((plano) => (
                            <li key={plano.nome} className={styles.planoItem}>
                                <div className={styles.planoInfo}>
                                    <span className={styles.planoNome}>{plano.nome}</span>
                                    <span className={styles.planoLabel}>{plano.descricao}</span>
                                </div>
                                <div className={styles.planoPreco}>
                                    <span className={styles.planoValor}>{plano.valor}</span>
                                    <span className={styles.planoPeriodo}>{plano.periodo}</span>
                                </div>
                            </li>
                        ))}
                    </ul>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Aula experimental</h2>
                    <p className={styles.paragraph}>
                        Pra você conhecer de perto o método de treinamento, te convido pra fazer
                        uma <strong>aula experimental</strong> com a gente! Tenho certeza que você
                        vai curtir a energia da turma e a dinâmica do treino.
                    </p>
                </section>

                <div className={styles.ctaGroup}>
                    <a
                        href={whatsappUrl(
                            'Olá! Vim pelo Pro Beach e gostaria de saber mais sobre os planos.'
                        )}
                        className={styles.cta}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Quero um plano — WhatsApp
                    </a>
                    <a
                        href={whatsappUrl(
                            'Olá! Vim pelo Pro Beach e gostaria de agendar uma aula experimental.'
                        )}
                        className={styles.ctaSecondary}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Agendar aula experimental
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Valores_team_probeach;
